(() => {
  const player = document.querySelector('.vg-player[data-video-id] iframe');
  if (!player) return;
  const clips = new Map([...document.querySelectorAll('[data-video-chapter]')].map(link => [link.dataset.videoChapter, link]));
  function seek(value, autoplay) {
    if (!/^\d+$/.test(value || '') || !clips.has(value)) return false;
    const url = new URL(player.src);
    url.searchParams.set('start', value);
    if (autoplay) url.searchParams.set('autoplay', '1');
    else url.searchParams.delete('autoplay');
    player.src = url.href;
    return true;
  }
  function restore() { seek(new URL(location.href).searchParams.get('t'), false); }
  restore();
  document.addEventListener('click', event => {
    const link = event.target.closest?.('[data-video-chapter]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!seek(link.dataset.videoChapter, true)) return;
    event.preventDefault();
    history.pushState(null, '', link.href);
    player.scrollIntoView({ block: 'center', behavior: 'auto' });
  });
  window.addEventListener('popstate', () => {
    const value = new URL(location.href).searchParams.get('t') || '0';
    seek(value, false);
  });
})();
